export interface ZodiacTheme {
  name: string
  icon: string
  element: string
  bg: string
  text: string
  border: string
  gradient: string
  lightGradient: string
  ring: string
}

export const zodiacThemes: Record<string, ZodiacTheme> = {
  Aries: {
    name: 'Овен',
    icon: '♈',
    element: 'Огонь',
    bg: 'bg-rose-50',
    text: 'text-rose-600',
    border: 'border-rose-200',
    gradient: 'from-rose-500 to-orange-500',
    lightGradient: 'from-rose-50 to-orange-50',
    ring: 'ring-rose-500',
  },
  Taurus: {
    name: 'Телец',
    icon: '♉',
    element: 'Земля',
    bg: 'bg-emerald-50',
    text: 'text-emerald-600',
    border: 'border-emerald-200',
    gradient: 'from-emerald-500 to-teal-500',
    lightGradient: 'from-emerald-50 to-teal-50',
    ring: 'ring-emerald-500',
  },
  Gemini: {
    name: 'Близнецы',
    icon: '♊',
    element: 'Воздух',
    bg: 'bg-yellow-50',
    text: 'text-yellow-600',
    border: 'border-yellow-200',
    gradient: 'from-yellow-400 to-amber-500',
    lightGradient: 'from-yellow-50 to-amber-50',
    ring: 'ring-yellow-400',
  },
  Cancer: {
    name: 'Рак',
    icon: '♋',
    element: 'Вода',
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    border: 'border-slate-300',
    gradient: 'from-slate-400 to-slate-600',
    lightGradient: 'from-slate-50 to-slate-100',
    ring: 'ring-slate-400',
  },
  Leo: {
    name: 'Лев',
    icon: '♌',
    element: 'Огонь',
    bg: 'bg-amber-50',
    text: 'text-amber-600',
    border: 'border-amber-200',
    gradient: 'from-amber-400 to-orange-500',
    lightGradient: 'from-amber-50 to-orange-50',
    ring: 'ring-amber-400',
  },
  Virgo: {
    name: 'Дева',
    icon: '♍',
    element: 'Земля',
    bg: 'bg-lime-50',
    text: 'text-lime-600',
    border: 'border-lime-200',
    gradient: 'from-lime-500 to-green-600',
    lightGradient: 'from-lime-50 to-green-50',
    ring: 'ring-lime-500',
  },
  Libra: {
    name: 'Весы',
    icon: '♎',
    element: 'Воздух',
    bg: 'bg-pink-50',
    text: 'text-pink-600',
    border: 'border-pink-200',
    gradient: 'from-pink-400 to-rose-400',
    lightGradient: 'from-pink-50 to-rose-50',
    ring: 'ring-pink-400',
  },
  Scorpio: {
    name: 'Скорпион',
    icon: '♏',
    element: 'Вода',
    bg: 'bg-red-50',
    text: 'text-red-600',
    border: 'border-red-200',
    gradient: 'from-red-600 to-rose-700',
    lightGradient: 'from-red-50 to-rose-50',
    ring: 'ring-red-600',
  },
  Sagittarius: {
    name: 'Стрелец',
    icon: '♐',
    element: 'Огонь',
    bg: 'bg-purple-50',
    text: 'text-purple-600',
    border: 'border-purple-200',
    gradient: 'from-purple-500 to-indigo-500',
    lightGradient: 'from-purple-50 to-indigo-50',
    ring: 'ring-purple-500',
  },
  Capricorn: {
    name: 'Козерог',
    icon: '♑',
    element: 'Земля',
    bg: 'bg-stone-100',
    text: 'text-stone-700',
    border: 'border-stone-300',
    gradient: 'from-stone-600 to-stone-800',
    lightGradient: 'from-stone-50 to-stone-100',
    ring: 'ring-stone-600',
  },
  Aquarius: {
    name: 'Водолей',
    icon: '♒',
    element: 'Воздух',
    bg: 'bg-cyan-50',
    text: 'text-cyan-600',
    border: 'border-cyan-200',
    gradient: 'from-cyan-400 to-blue-500',
    lightGradient: 'from-cyan-50 to-blue-50',
    ring: 'ring-cyan-400',
  },
  Pisces: {
    name: 'Рыбы',
    icon: '♓',
    element: 'Вода',
    bg: 'bg-teal-50',
    text: 'text-teal-600',
    border: 'border-teal-200',
    gradient: 'from-teal-400 to-emerald-500',
    lightGradient: 'from-teal-50 to-emerald-50',
    ring: 'ring-teal-400',
  },
  Default: {
    name: 'Неизвестно',
    icon: '✨',
    element: 'Эфир',
    bg: 'bg-indigo-50',
    text: 'text-indigo-600',
    border: 'border-indigo-200',
    gradient: 'from-indigo-500 to-purple-600',
    lightGradient: 'from-indigo-50 to-purple-50',
    ring: 'ring-indigo-500',
  },
}

export const getZodiacSign = (dateString: string): string => {
  if (!dateString) return 'Default'
  const date = new Date(dateString)
  const month = date.getMonth() + 1
  const day = date.getDate()

  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'Aries'
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'Taurus'
  if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'Gemini'
  if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'Cancer'
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'Leo'
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'Virgo'
  if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'Libra'
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21))
    return 'Scorpio'
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21))
    return 'Sagittarius'
  if ((month === 12 && day >= 22) || (month === 1 && day <= 19))
    return 'Capricorn'
  if ((month === 1 && day >= 20) || (month === 2 && day <= 18))
    return 'Aquarius'
  if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return 'Pisces'

  return 'Default'
}
